import { render, staticRenderFns } from "./category_mention_container.vue?vue&type=template&id=194a4804"
import script from "./category_mention_container.vue?vue&type=script&lang=js"
export * from "./category_mention_container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports